import type { IReservationSettingsConfiguration } from '@/interfaces/IReservationSettings';

export type TReservationDepositScope = 'inherit' | 'always' | 'never';
export type IReservationDepositScopeSettings = Pick<
  IReservationSettingsConfiguration['settings'],
  'depositMode' | 'depositAmountPerPerson' | 'mpConnected'
>;

export function reservationDepositScope(
  value: boolean | null
): TReservationDepositScope {
  return value === null ? 'inherit' : value ? 'always' : 'never';
}

export function reservationDepositRequired(
  scope: string
): boolean | null | undefined {
  if (scope === 'inherit') return null;
  if (scope === 'always') return true;
  if (scope === 'never') return false;
  return undefined;
}

export function canSelectReservationDepositScope(
  scope: string,
  settings: IReservationDepositScopeSettings,
  disabled = false
): boolean {
  if (disabled || !settings.mpConnected) return false;
  const value = reservationDepositRequired(scope);
  if (value === undefined) return false;
  return (
    value !== true ||
    (settings.depositMode !== 'none' &&
      Number.isFinite(settings.depositAmountPerPerson) &&
      settings.depositAmountPerPerson > 0)
  );
}

/** Only compare an existing record when saving that same shift or date. */
export function reservationDepositScopePatch(
  value: boolean | null,
  original?: { depositRequired: boolean | null }
): { depositRequired?: boolean | null } {
  return original && original.depositRequired === value
    ? {}
    : { depositRequired: value };
}
